import { UserPlus, UserCheck } from "lucide-react"
import { Button } from "@city-sage/aurum-avis-labs-components"
import { Link } from "@tanstack/react-router"
import { useTranslation } from 'react-i18next'
import { Avatar } from "../Avatar"
import { useFollow } from "../../lib/useFollow"
import { Account } from "@city-sage/core-client"

interface ItineraryAuthorBannerProps {
  account: Account
  className?: string
}

export function ItineraryAuthorBanner({ account, className = "" }: ItineraryAuthorBannerProps) {
  const { t } = useTranslation()
  
  const { 
    isFollowing,
    canFollow,
    isPending: isToggling,
    toggleFollow,
  } = useFollow({ userId: account.id })

  return (
    <div className={`snap-start flex-shrink-0 bg-gray-100 border-b border-gray-200 px-4 py-3 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Avatar 
            account={account} 
            className="w-8 h-8" 
          />
          <Link to="/users/$userId" params={{ userId: account.id }}>
            <span className="font-medium text-gray-900 text-sm hover:text-purple-600 transition-colors">
              @{account.userName}
            </span>
          </Link>
        </div>
        
        {/* Follow Button */}
        {canFollow && (
          <Button 
            size="sm" 
            onClick={toggleFollow}
            disabled={isToggling}
            className={`h-7 px-2 text-xs ${
              isFollowing 
                ? 'bg-gray-200 hover:bg-gray-300 text-gray-700 border border-gray-300' 
                : 'bg-primary hover:bg-primary/90 text-primary-foreground'
            }`}
          >
            {isToggling ? (
              <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                {isFollowing ? (
                  <UserCheck className="w-3 h-3 mr-1" />
                ) : (
                  <UserPlus className="w-3 h-3 mr-1" />
                )}
              </>
            )}
            {isToggling 
              ? t('components.author.following') 
              : isFollowing 
                ? t('components.author.following') 
                : t('components.author.follow')
            }
          </Button>
        )}
      </div>
    </div>
  )
} 